export default {
  '_b._qhyy': 'Сменить язык',

  '_a._jzz': 'Загрузка...',

  '_a._jzgd': 'Загрузить ещё',

  '_a._wct': 'Добро пожаловать',

  '_a._gd': 'Ещё',

  '_a._bf': 'Воспроизвести',

  '_a._bcz': 'Сохранение...',

  '_a._sctp': 'Загрузить изображение',

  '_dl._qssyx': 'Введите адрес электронной почты',

  '_dl._qssmm': 'Введите пароль',

  '_dl._ann': 'Войти',

  '_dl._hmyzh': 'Нет учётной записи?',

  '_dl._qzc': 'Зарегистрироваться',

  '_dl._yzhl': 'У вас есть аккаунт?',

  '_dl._qdl': 'Войти',

  '_dl._srqrmm': 'Введите пароль для подтверждения',
  '_dl._sryqm': 'Введите код приглашения',

  '_dl._sryzm': 'Введите код подтверждения',

  '_dl._ljzc': 'Зарегистрироваться',

  '_dl._zcbsty': 'Регистрация означает, что вы прочитали и согласны с условиями',

  '_dl._yszc': 'Политика конфиденциальности',

  '_dl._lcmmbyy': 'Два пароля не совпадают',

  '_yzm._fsyzm': 'Отправка кода подтверждения',

  '_yzm._cxfs': '({time}) Отправить повторно',

  '_yzm._fsz': 'Отправка...',

  '_yzm._fscg': 'Отправлено успешно',

  '_h._zrm': 'Самые популярные',

  '_h._zxd': 'Самые новые',

  '_h._phb': 'Рейтинг',

  '_h._qz': 'Обои',
  '_h._ssww': 'Поиск',

  '_h._lsjl': 'История',

  '_h._gd': 'Ещё',

  '_h._dl': 'Вход',

  '_h._ye': 'Баланс',

  '_h._dj': 'Заморожено',

  '_h._ybp': 'Панель управления',

  '_h._wdqb': 'Мой кошелёк',

  '_h._scjl': 'Избранное',

  '_h._xxzx': 'Центр сообщений',

  '_h._fxhy': 'Поделиться с Друзья',

  '_h._bzzx': 'Справочный центр',

  '_h._ggtf': 'Реклама',

  '_h._bqtz': 'Инвестиции в авторское право',

  '_h._sz': 'Настройки',

  '_sy._jx': 'Избранное',

  '_sy._xpfb': 'Новинки',

  '_sy._gdsp': 'Больше видео',

  '_qz._jbqz': 'Красивая коллекция обоев',

  '_qz._ssqz': 'Поиск обоев',

  '_qz._qb': 'Все',

  '_qz._zrfg': 'Природный пейзаж',

  '_qz._cxys': 'Абстрактное искусство',

  '_qz._csjz': 'Городская архитектура',

  '_qz._dmyx': 'Аниме и Игры',

  '_qz._yzxk': 'Космический космос',

  '_qz._yl': 'Предварительный просмотр',

  '_qz._xzqz': 'Скачать обои',

  '_qz._fbl': 'Разрешение',

  '_qz._fl': 'Категория',

  '_qz._jzz': 'Загрузка',

  '_qz._myzdpp': 'Подходящие обои не найдены',

  '_sp._xyjscl': 'Требуется разблокировка для просмотра',

  '_sp._cz': 'Пополнить баланс',
  '_sp._jsqj': 'Разблокировать все эпизоды',

  '_sp._jsbj': 'Разблокировать этот эпизод',

  '_sp._sc': 'Добавить в избранное',

  '_sp._fx': 'Поделиться',

  '_sp._jsqjjs': 'Подтвердите оплату за {a} и разблокируйте все эпизоды?',

  '_sp._jsbjjs': 'Подтвердить оплату за {a} и разблокировать все эпизоды?',

  '_sp._zfz': 'Оплата в процессе...',

  '_sp._qrzf': 'Подтвердить оплату',

  '_sp._qx': 'Отмена',

  '_qz._smrc': 'Восход солнца над горами',

  '_qz._cxjh': 'Абстрактная геометрия',

  '_qz._dsyj': 'Ночной городской вид',

  '_qz._dmfj': 'Аниме-пейзаж',

  '_qz._hhxk': 'Бескрайнее звёздное небо',

  '_qz._slmw': 'Лесной туман',
  '_qz._scld': 'Цветовой поток',

  '_qz._xdjz': 'Современный Архитектура',

  '_qb._cbjl': 'Записи о депозитах',

  '_qb._jyjl': 'Записи о транзакциях',

  '_qb._bddz': 'Привязанный адрес',

  '_qb._txjl': 'Записи о снятии',

  '_m._tcdl': 'Выход',

  '_m._cb': 'Депозит',

  '_m._tb': 'Снятие',

  '_cb._ssdz': 'Поиск валюты или адреса',

  '_cb._bz': 'Валюта',

  '_cb._je': 'Сумма',

  '_cb._dz': 'Адрес',

  '_cb._sj': 'Время',

  '_cb._cz': 'Операция',

  '_cb._zwjl': 'Нет записей о транзакциях',
  '_cb._dny': 'Страница {a} из {b}',

  '_cb._jyxq': 'Информация о транзакции',

  '_cb._jydz': 'Адрес транзакции',

  '_cb._zt': 'Статус',

  '_cb._yqr': 'Подтверждено',

  '_cb._qb': 'Все',

  '_cb._jt': 'Сегодня',

  '_cb._j7t': 'Последние 7 дней',

  '_cb._j30t': 'Последние 30 дней',

  '_cb._zw': 'Нет',

  '_cb._fzcg': 'Адрес скопирован в буфер обмена',

  '_jyjl._ssdz': 'Поиск валюты или адреса',

  '_jyjl._lx': 'Тип',

  '_jyjl._je': 'Сумма',

  '_jyjl._ye': 'Баланс',
  '_jyjl._dj': 'Заморожено',

  '_jyjl._sj': 'Время',

  '_jyjl._cz': 'Операция',

  '_jyjl._zwjyjl': 'Нет записей о транзакциях',

  '_jyjl._czsx': 'Сбросить фильтр',

  '_jyjl._dny': 'Страница {a} из {b}',

  '_jyjl._jyxq': 'Детали транзакции',

  '_jyjl._jylx': 'Тип транзакции',

  '_jyjl._jyje': 'Сумма транзакции',

  '_jyjl._jyhye': 'Баланс после транзакции',

  '_jyjl._djye': 'Замороженная сумма',

  '_jyjl._jysj': 'Транзакция время',

  '_jyjl._jyzt': 'Статус транзакции',

  '_jyjl._ywc': 'Завершено',

  '_jyjl._qb': 'Все',

  '_jyjl._jt': 'Сегодня',

  '_jyjl._j7t': 'Последние 7 дней',

  '_jyjl._j30t': 'Последние 30 дней',

  '_jyjl._tp1': 'Депозит',

  '_jyjl._tp2': 'Вывод',

  '_jyjl._tp3': 'Платеж',

  '_jyjl._tp4': 'Депозит',

  '_jyjl._tp5': 'Заморожен',

  '_jyjl._tp6': 'Доход',

  '_jyjl._tp7': 'Награды за приглашение',

  '_jyjl._tp8': 'Награды за вход',

  '_jyjl._tp9': 'Награды за рефералов',

  '_jyjl._tp10': 'Награды за просмотр видео',
  '_jyjl._tp11': 'Бонус за регистрацию',
  '_jyjl._tp12': 'Вывод средств отклонен',
  '_jyjl._tp13': 'Сообщение Red Packet',

  '_jyjl._tp14': 'Внутренний перевод',

  '_cb._shz': 'На рассмотрении',

  '_cb._yyg': 'Одобрено',

  '_cb._ybh': 'Отклонено',

  '_bddz._tjdz': 'Добавить адрес',

  '_bddz._ssdz': 'Поиск адреса',

  '_bddz._bz': 'Валюта',

  '_bddz._dz': 'Адрес',

  '_bddz._sysj': 'Время использования',

  '_bddz._cz': 'Операция',

  '_bddz._zwjl': 'Нет записей об адресе',

  '_bddz._dny': 'Страница {a} из {b}',

  '_bddz._dzewm': 'QR-код адреса',

  '_bddz._fzdz': 'Копировать адрес',
  '_bddz._dzxq': 'Данные об адресе',

  '_bddz._wl': 'Сеть',

  '_bddz._tjsj': 'Добавленное время',

  '_bddz._bzwa': 'Примечания',

  '_bddz._ntq': '{a} дн. назад',

  '_bddz._nxsq': '{a} ч. назад',

  '_bddz._nfzq': '{a} мин. назад',

  '_bddz._ngg': 'Только что',

  '_bddz._dzyfz': 'Адрес скопирован в буфер обмена',

  '_bddz._scqr': 'Подтверждение удаления',

  '_bddz._scqrdz': 'Вы уверены, что хотите удалить этот адрес?',

  '_bddz._qr': 'Подтвердить',

  '_bddz._qx': 'Отмена',

  '_bddz._scdzcg': 'Адрес успешно удалён',

  '_txjl._ztsx': 'Фильтр статусов',

  '_txjl._qbzt': 'Все статусы',

  '_txjl._shz': 'На рассмотрении',

  '_txjl._ytg': 'Одобрено',

  '_txjl._yjj': 'Отклонено',

  '_txjl._ssdz': 'Поиск адреса или суммы',

  '_txjl._bz': 'Валюта',

  '_txjl._je': 'Сумма',

  '_txjl._dz': 'Адрес',

  '_txjl._zt': 'Статус',

  '_txjl._sj': 'Время',

  '_txjl._cz': 'Операция',

  '_txjl._zwjl': 'Нет записей о транзакциях',

  '_txjl._czsx': 'Сбросить фильтр',

  '_txjl._dny': 'Страница {a} из {b}',

  '_txjl._jyxq': 'Детали транзакции',

  '_txjl._skdz': 'Платежный адрес',

  '_txjl._jysj': 'Время транзакции',

  '_txjl._jyzt': 'Статус транзакции',

  '_txjl._fzdz': 'Адрес скопирован в буфер обмена',

  '_cbsq._bz': 'Валюта',

  '_cbsq._wl': 'Сеть',

  '_cbsq._erwm': 'QR-код',

  '_cbsq._fzdz': 'Копировать адрес',

  '_txsq._bz': 'Валюта',

  '_txsq._wl': 'Сеть',

  '_txsq._ye': 'Баланс',

  '_txsq._sxf': 'Комиссия за транзакцию',

  '_txsq._zxtx': 'Минимальная сумма вывода',

  '_txsq._txdz': 'Адрес для вывода',

  '_txsq._qxztxdz': 'Выберите адрес для вывода',

  '_txsq._txje': 'Вывод Сумма',

  '_txsq._qsrtxje': 'Введите сумму вывода',

  '_txsq._yxyzm': 'Код подтверждения адреса электронной почты',
  '_txsq._qsryxyzm': 'Введите код подтверждения',

  '_txsq._ljtx': 'Вывести немедленно',

  '_jl._wxhd': 'Избранное',

  '_jl._lsjl': 'История',

  '_xx._bt': 'Центр сообщений',

  '_xx._wjl': 'Нет записей',

  '_xx._zsmyxx': 'Сейчас сообщений нет',

  '_xx._sxxx': 'Обновить сообщения',

  '_xx._sxcg': 'Обновить успешно',

  '_fx._fxhy': 'Поделиться с друзьями',

  '_fx._smfx': 'Отсканируйте QR-код, чтобы поделиться с друзьями',

  '_fx._jlsm': 'Описание программы вознаграждений',

  '_fx._jlsm1': '1. За друзей, которых вы пригласите напрямую (сокращённо "Уровень 1"), вы будете получать {a}% от их заработка',
  '_fx._jlsm2': '2. Если ваш друг 1-го уровня пригласит других друзей (Уровень 2), вы будете получать {a}% от их заработка.',

  '_fx._jlsm3': '3. Если ваш друг 2-го уровня пригласит других друзей (Уровень 3), вы будете получать {a}% от их заработка.',

  '_fx._fzlj': 'Скопировать ссылку',

  '_bzzx._bzzx': 'Справочный центр',

  '_bzzx._rhzczh': 'Как зарегистрировать учётную запись',

  '_bzzx._zclc': 'Процесс регистрации',

  '_bzzx._rhzcxyh': 'Как зарегистрировать новую учётную запись?',

  '_bzzx._rhzcxyh1': 'Нажмите кнопку «Зарегистрироваться», введите свой адрес электронной почты, установите пароль и пройдите подтверждение электронной почты для успешной регистрации учётной записи.',

  '_bzzx._rhcz': 'Как пополнить счёт?',
  '_bzzx._rhcz1': 'Процесс пополнения',

  '_bzzx._rhcz2': 'Подробная инструкция по пополнению',

  '_bzzx._rhcz3': 'Нажмите «Мой кошелёк», «Депозит», выберите криптовалюту, которую хотите внести, и переведите её на указанный адрес.',

  '_bzzx._rhjsdj': 'Как разблокировать короткие драмы',

  '_bzzx._rhjsdj2': 'Нажмите на одну серию, чтобы разблокировать сюжетную линию и увидеть больше захватывающего контента.',

  '_bzzx._rhtx': 'Как вывести средства со своего счёта',

  '_bzzx._rhtx1': '1. Нажмите «Мой кошелёк», «Адрес для вывода» и добавьте соответствующий адрес для вывода криптовалюты.<br>2. Нажмите «Вывод», выберите соответствующую криптовалюту, выберите привязанный адрес, введите сумму вывода и дождитесь поступления средств.',

  '_bzzx._qtwt': 'Другие вопросы',

  '_bzzx._qtwt1': 'Как связаться со службой поддержки?',

  '_bzzx._qtwt2': 'Вы можете связаться с нами через онлайн-службу поддержки в правом нижнем углу сайта, по электронной почте или по телефону горячей линии.',

  '_bzzx._myzdwt': 'Не нашли нужный ответ?',

  '_bzzx._khjybbzn': 'Наша служба поддержки клиентов будет рада оказать вам дальнейшую помощь.',

  '_bzzx._lxkf': 'Связаться со службой поддержки',

  '_ggtf._bt1': 'Размещение рекламы',

  '_ggtf._splb': 'Список видео',

  '_ggtf._wcyd': 'Мои участия',

  '_ggtf._hdbm': 'Код активности',

  '_ggtf._tian': 'День',

  '_ggtf._kssj': 'Время начала',

  '_ggtf._jssj': 'Время окончания',
  '_ggtf._ddvp': 'Достигнут уровень VIP{a}, среднее количество участий на человека: {b}',

  '_ggtf._hdzt': 'Статус активности',

  '_ggtf._wks': 'Не начато',

  '_ggtf._ycy': 'Участвую',

  '_ggtf._qg': 'Распродажа',

  '_ggtf._mygdl': 'Доступных мест больше нет',

  '_ggtf._qgrtd': 'Слишком много участников, попробуйте ещё раз',

  '_ggtf._hdxq': 'Подробности об акции',

  '_ggtf._hdjs': 'Описание акции',

  '_ggtf._cyyq': 'Требования к участию',

  '_ggtf._zdtz': 'Минимальная сумма инвестиций',

  '_ggtf._vpdj': 'VIP-уровень',

  '_ggtf._rjcy': 'Среднее количество участников на человека',

  '_ggtf._gmje': 'Сумма покупки',
  '_ggtf._qsrgmje': 'Укажите сумму покупки',

  '_ggtf._qx': 'Отмена',

  '_ggtf._ljcy': 'Принять участие',

  '_ggtf._ssjymm': 'Введите пароль транзакции',

  '_ggtf._qssjymm': 'Введите пароль транзакции',

  '_ggtf._ji': 'Уровень',

  '_ggtf._ci': 'Время',

  '_ggtf._zdgm': 'Минимальная сумма покупки',

  '_ggtf._zggm': 'Максимальная сумма покупки',

  '_ggtf._zfz': 'Оплата в процессе...',

  '_wdtg._wjl': 'Записей об участии пока нет',

  '_wdtg._tzje': 'Сумма инвестиций',

  '_wdtg._zsy': 'Общий доход',

  '_wdtg._hdts': 'Количество дней активности',
  '_wdtg._cysj': 'Время участия',

  '_wdtg._qzf': 'Перейти к оплате',

  '_wdtg._jxz': 'В процессе',

  '_wdtg._djszje': 'Общая сумма к оплате',

  '_wdtg._gjb': 'Всего транзакций: {a}',

  '_wdtg._djs': 'К оплате',

  '_wdtg._zrsy': 'Вчерашний доход',

  '_wdtg._dbl': 'Просмотры',

  '_wdtg._bfl': 'Воспроизведения',

  '_wdtg._wdsy': 'Мой доход',

  '_wdtg._bqffc': 'Доход правообладателя Поделиться',

  '_wdtg._mr0djs': 'Вчерашний доход рассчитывается ежедневно в 00:00',

  '_wdtg._jrsy': 'Сегодняшний доход',

  '_wdtg._mygd': 'Больше нет',

  '_bqyy._bqyy': 'Запись на приём по вопросам сотрудничества в сфере авторских прав',

  '_bqyy._qrbq': 'Подтвердить заявку на приём по вопросам сотрудничества в сфере авторских прав?',

  '_bqyy._qx': 'Отмена',

  '_bqyy._tjyy': 'Отправить заявку на приём',

  '_bqyy._spsq': 'Запись на приём по вопросам сотрудничества в сфере авторских прав на видео',

  '_bqyy._spsy': 'Продвигайте свои видео среди правообладателей и получайте больше трафика и дохода!',

  '_bqyy._ljyy': 'Запишитесь на приём',

  '_bqyy._sphz': 'Что такое заявка на сотрудничество в области авторских прав на видео?',

  '_bqyy._sphzsm': 'Заявка на сотрудничество в области авторских прав на видео обеспечивает более тесное сотрудничество в сфере продвижения и взаимовыгодные результаты. Благодаря заявке вы получите признание правообладателей и возможность тесного сотрудничества с ними, что позволит вам расширить охват аудитории и увеличить доход.',

  '_bqyy._sqhch': 'Преимущества подачи заявки на сотрудничество в области авторских прав',
  '_bqyy._llfz': 'Поддержка трафика',

  '_bqyy._llfzsm': 'Получите возможности продвижения на платформе, увеличьте охват и количество просмотров',

  '_bqyy._sytg': 'Увеличение дохода',

  '_bqyy._sytgsm': 'Получите более высокий доход от рекламы и возможности делового сотрудничества',

  '_bqyy._yxhz': 'Приоритетное сотрудничество',

  '_bqyy._yxhzsm': 'Приоритетное участие в официальных мероприятиях платформы и проектах делового сотрудничества',

  '_bqyy._yytj': 'Требования к бронированию',

  '_bqyy._sptg': 'Требования к продвижению видеорекламы',

  '_bqyy._sptgsm': 'Участвуйте в Как минимум одно рекламное видео, соответствующее стандартам платформы',

  '_bqyy._yysm': 'После нажатия кнопки "Забронировать" наши сотрудники свяжутся с вами в течение 3 рабочих дней',

  '_ybp._wdsy': 'Мой доход',
  '_ybp._dqye': 'Текущий баланс',

  '_ybp._jr': 'Сегодня',

  '_ybp._jrzsy': 'Общий доход за сегодня',

  '_ybp._ljzsy': 'Общий совокупный доход',

  '_ybp._tgfh': 'Бонус за рефералов',

  '_ybp._ljsy': 'Общий доход',

  '_ybp._bqsy': 'Доход от авторских прав',

  '_ybp._yqfh': 'Реферал Бонус',

  '_ybp._mrsy': 'Ежедневный доход',

  '_ybp._tgsy': 'Доход от рефералов',

  '_tjdz._tjxd': 'Добавить новый адрес',

  '_tjdz._xzbz': 'Выбрать валюту',

  '_tjdz._qbdz': 'Адрес кошелька',

  '_tjdz._srdz': 'Введите адрес кошелька',
  '_tjdz._qx': 'Отмена',

  '_tjdz._bc': 'Сохранить',

  '_sz._smrz': 'Аутентификация по настоящему имени',

  '_sz._rzlx': 'Тип аутентификации',

  '_sz._sfzzm': 'Фотография лицевой стороны удостоверения личности',

  '_sz._sfzfm': 'Фото на обороте удостоверения личности',

  '_sz._zsxm': 'Настоящее имя',

  '_sz._qsrzsxm': 'Пожалуйста, введите настоящее имя',

  '_sz._sfzhm': 'Номер удостоверения личности',

  '_sz._qsrsfzhm': 'Пожалуйста, введите номер удостоверения личности',

  '_sz._yyzz': 'Лицензия на ведение бизнеса',

  '_sz._qymc': 'Название компании',

  '_sz._yyzzh': 'Номер лицензии на ведение бизнеса',

  '_sz._qsrqymc': 'Пожалуйста, введите название компании',

  '_sz._qsryyzzh': 'Пожалуйста, введите номер лицензии на ведение бизнеса',

  '_sz._qx': 'Отмена',

  '_sz._tjrz': 'Отправить на проверку',

  '_sz._zt': 'Статус',

  '_sz._gr': 'Физическое лицо',

  '_sz._qy': 'Компания',

  '_sz._shz': 'На рассмотрении',

  '_sz._ytg': 'Одобрено',

  '_sz._ybh': 'Отклонено',

  '_mm._xgmm': 'Сменить пароль',

  '_mm._dqxg': 'Регулярно меняйте пароль для обеспечения безопасности аккаунта',

  '_mm._dqmm': 'Текущий пароль',

  '_mm._xmm': 'Новый пароль',

  '_mm._qrxmm': 'Подтвердите новый пароль',

  '_mm._qx': 'Отмена',
  '_mm._qrxg': 'Подтвердите изменения',

  '_jymm._xgjymm': 'Сменить пароль транзакции',

  '_szzx._sz': 'Настройки',

  '_szzx._yrz': 'Аутентифицирован',

  '_szzx._wrz': 'Не аутентифицирован',

  '_szzx._jymm': 'Пароль транзакции',

  '_szzx._szjymm': 'Установить или изменить пароль транзакции',

  '_szzx._tcdl': 'Выйти',

  '_szzx._qdtcdl': 'Вы уверены, что хотите выйти?',

  '_szzx._qrtc': 'Подтвердите выход',

  '_szzx._qx': 'Отмена',

  '_yj._gy': 'О компании',

  '_yj._lxwm': 'Связаться с нами',

  '_yj._yszc': 'Политика конфиденциальности',

  '_yj._yhxy': 'Пользовательское соглашение',

  '_cd._gszz': 'Квалификация компании',

  '_cd._wmyy': 'Мы обладаем всеми отраслевыми квалификациями и сертификатами, предоставляя пользователям легальные, безопасные и высококачественные видеоуслуги',

  '_cd._yyzz': 'Действительное подтверждение законности деятельности компании, подтверждающее официальную регистрационную информацию и сферу деятельности',

  '_cd._yyzz2': 'Законно полученная сертифицированная компанией лицензия на ведение бизнеса, подтверждающая законность и соответствие платформы',

  '_bz._lxkf': 'Нажмите ниже, чтобы связаться с клиентом или свяжитесь с нами по электронной почте или по горячей линии службы поддержки клиентов',

  '_sz._bjtx': 'Изменить',

  '_sz._bjxx': 'Редактировать сообщение',

  '_sz._tx': 'Аватар',

  '_sz._bcun': 'Сохранить',

  '_db._zskf': 'Связаться с поддержкой',
  '_db._zsry': 'Персональный менеджер',
  '_db._wdq': 'Не прочитано',
  '_db._ydq': 'Прочитано',

  '_sc._sctp': 'Загрузить фото',
  '_sc._xztp': 'Выбрать фото',
  '_sc._fstp': 'Отправить фото',
  '_sc._qx': 'Отмена',
  '_sc._hd': 'Хорошо',

  '_zcyl._zcbt': 'Бонус за регистрацию',
  '_zcyl._djdkhb': 'Нажмите, чтобы открыть красный конверт',
  '_zcyl._zclj': 'Подарок за регистрацию',
  '_zcyl._hmyzh': 'Еще нет аккаунта?',
  '_zcyl._qzc': 'Зарегистрироваться',
  '_zcyl._qxdjhb': 'Сначала получите свой бонус',
  '_zcyl._qwzc': 'Перейти к регистрации',
  '_zcyl._hbysy': 'Бонус уже использован',

  '_ggtg._qhz': 'Перевести',
  '_ggtg._dqye': 'Текущий баланс',
  '_ggtg._qcz': 'Пополнить',
  '_ggtg._hzje': 'Сумма перевода',
  '_ggtg._ljhz': 'Перевести сейчас',
  '_ggtg._yebz': 'Недостаточно средств',

  '_sq._bhbt': 'Отклонено',

  '_sq._bhyy': 'Причина отклонения',

  '_xx._ntq': '{n} дней назад',

  '_xx._nxsq': '{n} часов назад',

  '_xx._nfzq': '{n} минут назад',

  '_xx._nggq': 'Только что',

  '_xx._djckgd': 'Нажмите, чтобы посмотреть больше',

  '_ct._zt': 'Статус',

  '_ct._ljz': 'Подключение',

  '_ct._ylj': 'Подключено',

  '_ct._ltlieb': 'Список чатов',

  '_ct._bnhzj': 'Не могу общаться сам с собой',

  '_ct._cylb': 'Список участников',

  '_hb._fhb': 'Красный конверт',

  '_hb._dqye': 'Текущий баланс',

  '_hb._fsd': 'Отправлено',

  '_hb._hbje': 'Сумма красного конверта',

  '_hb._qshuru': 'Пожалуйста, введите сумму красного конверта',

  '_hb._ljfs': "Отправлено' Сейчас",

  '_hb._hbz': 'Благословение в красном конверте',
  '_hb._qshuruzhu': 'Пожалуйста, введите ваше благословение',

  '_sp._cuow': 'Для просмотра эпизодов 1-10 необходимо разблокировать',

  '_bq._tzzq': 'Период инвестирования',

  '_bq._zrsy': 'Вчерашняя прибыль',

  '_bq._bqtz': 'Инвестиции в авторские права',

  '_bq._tzdj': 'Сумма инвестирования',

  '_bq._zfjz': 'Оплата должна быть произведена в течение 24 часов, в противном случае она будет считаться отказом!',

  '_bq._qzf': 'Произвести оплату',

  '_bq.jz': 'Срок',

  '_bq._ljzf': 'Оплатить сейчас',

  '_bq._sqbz': 'Примечания к заявке (необязательно)',

  '_bq._sqbzsm': "Пожалуйста, введите заявку' Примечания",

  '_bq._zzsqz': 'Заявка на авторские права находится в процессе рассмотрения...',

  '_app._xz': 'Загрузите приложение ReelShortBiz',

  '_app._smerm': 'Отсканируйте QR-код для загрузки',

  '_app._xzbt': 'Скачать приложение',

  '_m._yhzz': 'Банковский перевод',
  '_m._yhxx': 'Банковская информация',
  '_m._yhmz': 'Название банка',
  '_m._yhdz': 'Адрес банка',
  '_m._yhmc': 'Имя',
  '_m._yhzh': 'Счёт',
  '_m._yhlx': 'Тип',
  '_m._yhly': 'Маршрут',
  '_m._yhdm': 'Код',
  '_m._yhbz': 'Примечание',
  '_m._fzxx': 'Копировать информацию',

  '_m._zts': 'Подсказка',
  '_m._zyd1': '1. Пожалуйста, внимательно проверьте имя получателя, номер счета и код банка при переводе. Любая ошибка может привести к потере перевода',
  '_m._zyd2': '2. Рекомендуется выбрать «Отправитель оплачивает все комиссии», чтобы избежать недостаточной суммы получения из-за удержаний банка-посредника',
  '_m._zyd3': '3. Переводы обычно занимают 1-3 рабочих дня. Пожалуйста, ожидайте терпеливо. Если у вас есть вопросы, обратитесь в службу поддержки',
  '_m._zyd4': '4. Если у вас есть другие вопросы, обратитесь в службу поддержки',

  '_m._jyh': 'ID транзакции',
  '_m._jyje': 'Сумма',

  '_sp._dbye': 'Баланс VOD',
  '_sp.hzye': 'Перенос',
  '_sp._txje': 'Сумма переноса',
  '_sp._qsrtxje': 'Введите сумму переноса',
  '_sp._ljhz': 'Перенести сейчас',
  '_sp._yebz': 'Недостаточно средств',
  '_sp._qshuru': 'Введите правильную сумму перевода',
  '_sp._fanh': 'Назад',

  '_sp._tliu': 'Размещение рекламы',
  '_sp._xzgj': 'Выберите страну',
  '_sp._cdcw': 'Ошибка кодирования видео',
  '_ggtf._hot': 'Популярное',
  '_tl._tlsj': 'Время размещения',
  '_tl._xzxb': 'Выберите пол',
  '_tl._nan': 'Мужской',
  '_tl._nv': 'Женский',
  '_tl._hunhe': 'Смешанный',
  '_tl._xznl': 'Выберите возраст',
  '_sp._us': 'США',
  '_sp._en': 'Великобритания',
  '_sp._jp': 'Япония',
  '_sp._fr': 'Франция',
  '_sp._kr': 'Южная Корея',
  '_sp._de': 'Германия',
  '_sp._id': 'Индия',
  '_sp._in': 'Индонезия',
  '_sp._au': 'Австралия',
  '_sp._es': 'Испания',
  '_sp._my': 'Малайзия',
  '_sp._cn': 'Китай',
  '_ggtf._fanhui': 'Назад',
  '_ggtf._jymmts': 'Пожалуйста, подтвердите сумму транзакции и введите пароль',
  '_wdtg._wjl_desc': 'Вы еще не участвовали в рекламных кампаниях',
  '_wd._jxz': 'В процессе',
  '_wd._djs': 'Ожидает расчета',
  '_wd._ywc': 'Завершено',
  '_wd._jz': 'Срочно',
  '_wd._hz': 'Перевод',

  '_tl._tlfbqk': 'Распределение рекламных расходов',
  '_tl._tlfbqk_desc': 'Дни 1-5: 5% (Фаза холодного старта), Дни 6-10: 20% (Фаза проверки контента), Дни 11-15: 40% (Фаза построения IP), Дни 16-20: 35% (Фаза матрицы коротких сериалов)',

  '_nhz._sm': 'После перевода сумма будет зачислена на видеокошелек для разблокировки видеоконтента',
  '_nhz._zhzz': 'Перевод...',
  '_nhz._zzcg': 'Перевод успешен',
  '_nhz._zhzsb': 'Перевод не удался, попробуйте снова',
  '_m._fzcg': 'Скопировано успешно',
  '_m._fzsb': 'Не удалось скопировать, скопируйте вручную',
  '_m._zwfzxx': 'Нет информации для копирования',
  '_tx._qb': 'Все',
  'activity.detail': 'Детали активности',
  'activity.noDesc': 'Нет описания активности',
  'activity.desc': 'Описание активности',
  'activity.requirements': 'Требования к участию',
  'activity.minInvest': 'Минимальные инвестиции',
  'activity.vipLevel': 'VIP уровень',
  'activity.avgParticipation': 'Среднее участие',
  'activity.avgParticipationDesc': 'раз',
  'activity.country': 'Выберите страну',
  'activity.deliveryTime': 'Время показа',
  'activity.deliveryTimeDesc': 'дней',
  'activity.gender': 'Выберите пол',
  'activity.male': 'Мужской',
  'activity.female': 'Женский',
  'activity.mixed': 'Смешанный',
  'activity.age': 'Выберите возраст',
  'activity.amount': 'Сумма покупки',
  'activity.back': 'Назад',
  'activity.join': 'Участвовать',
  emptyData: 'Нет данных',
  emptyDataDesc: 'Нет участвующих рекламных кампаний',
  completedtlement: 'Истекло',
  preheat: 'Разогрев',
  progress: 'В процессе',
  settlement: 'Ожидает расчета',
  transfered: 'Переведено',
  completed: 'Завершено',
  activityCode: 'Код активности',
  touzAmount: 'Сумма инвестиций',
  activityDays: 'Дни активности',
  joinTime: 'Время участия',
  playSource: 'Распределение источников воспроизведения',
  allPlatforms: 'Все платформы',
  other: 'Другое',
  totalPlayNum: 'Общее количество просмотров',
  incomeSummary: 'Сводка доходов',
  totalPay: 'Оплата авторских прав',
  totalIncome: 'Общий доход',
  copyrightRatio: 'Доля правообладателя',
  promotionIncome: 'Доход от продвижения',
  copyrightIncome: 'Авторские отчисления',
  playNum: 'Количество просмотров',
  buyNum: 'Количество просмотров по запросу',
  incomeRate: 'Доля распределения',
  yjIncome: 'Прогнозируемый доход',
  paid: 'Оплачено',
  timeout: 'Истекло время',
  transfer: 'Перевести сейчас',
  loading: 'Загрузка...',
  loadMore: 'Загрузить еще',
  noMore: 'Больше нет',
  nightTime: 'Ночной период',
  morningTime: 'Утренний период',
  afternoonTime: 'Дневной период',
  eveningTime: 'Вечерний период',
  '_h._tc': 'Выйти',
  periodPayment: 'Периодическая оплата',
  periodPaymentDesc: 'Расчет проводится 4 раза в день в 4 периода, вы можете оплачивать авторские права по периодам',

  day: 'день',
  '_dl._hy': 'С возвращением',
  '_dl._cj': 'Создать аккаунт',
  '_dl._zmm': 'Сброс пароля',
  '_dl._hyDesc': 'Войдите в свой аккаунт, чтобы продолжить изучение интересного контента',
  '_dl._cjDesc': 'Присоединяйтесь к ReelShortBiz и начните своё увлекательное путешествие',
  '_dl._zmmDesc': 'Введите ваш email, и мы отправим код для сброса пароля',
  '_dl._hlgqsp': 'Огромная библиотека HD фильмов и видео',
  '_dl._gxhty': 'Персонализированные рекомендации',
  '_dl._ffddsp': 'Разнообразные короткие видео',
  '_dl._dlzh': 'Войти',
  '_dl._sdndyx': 'Введите ваш email и пароль для продолжения',
  '_dl._email': 'Email',
  '_dl._qsryx': 'Пожалуйста, введите ваш email',
  '_dl._dlmm': 'Пароль',
  '_dl._qsrmm': 'Пожалуйста, введите ваш пароль',
  '_dl._wjmm': 'Забыли пароль?',
  '_dl._immdl': 'Войти сейчас',
  '_dl._hmyzh2': 'Нет аккаунта?',
  '_dl._ljzc2': 'Зарегистрироваться',
  '_dl._cjzh': 'Создать аккаунт',
  '_dl._jswmd': 'Присоединяйтесь к ReelShortBiz и начните своё увлекательное путешествие',
  '_zh._qszmm': 'Пожалуйста, установите пароль',
  '_zh._qrmm': 'Подтвердите пароль',
  '_zh._qmm': 'Пожалуйста, введите пароль ещё раз',
  '_zc._yqm': 'Пригласительный код',
  '_zc._sryqm': 'Пожалуйста, введите пригласительный код',
  '_dl._yzm': 'Код подтверждения',
  '_dl._qsryzm': 'Пожалуйста, введите код подтверждения',
  '_dl._yjyzh': 'Уже есть аккаунт?',
  '_dl._zcbsty2': 'Регистрируясь, вы соглашаетесь с',
  '_dl._zcbstyDesc': 'Политикой конфиденциальности',
  '_dl._newmm': 'Новый пароль',
  '_dl._qszxmm': 'Пожалуйста, установите новый пароль',
  '_dl._qrmm': 'Подтвердите пароль',
  '_dl._qzcsrmm': 'Пожалуйста, введите новый пароль ещё раз',
  '_dl._czmm': 'Сбросить пароль',
  '_dl._xqlmm': 'Вспомнили пароль?',
  '_dl._fhdl': 'Вернуться к входу',
  '_dl._srdllmmbyz': 'Пароли не совпадают',
  '_dl._czcg': 'Пароль успешно сброшен',
  '_h._zc': 'Регистрация',
  // '_ybp._wdsy': 'Мой доход',
  '_ybp._jrsy': 'Доход за сегодня',
  '_ybp._jztr': 'По сравнению со вчера',
  '_ybp._bfl': 'Просмотры',
  '_ybp._dbl': 'Запросы',
  '_ybp._syqs': 'Тренд доходов',
  // '_ybp._jr': 'Сегодня',
  '_ybp._t': 'день',
  // '_ybp._dqye': 'Баланс счёта',
  '_ybp._djs': 'Ожидает расчёта',
  '_ybp._zhl': 'Коэффициент конверсии',
  '_ybp._sjgl': 'Обзор данных',
  '_ybp._zrsy': 'Доход за вчера',
  '_ybp._bysy': 'Доход за этот месяц',
  '_ybp._yysj': 'Операционные данные',
  '_ybp._zr': 'Вчера',
  '_ybp._zjfrs': 'Всего платных пользователей',
  '_ybp._mtdqje': 'Сумма к зачислению завтра',
  '_ybp._jsy': 'Чистый доход',
  '_ybp._bqfy': 'План оплаты лицензионных сборов',
  '_ybp._yzf': 'Оплачено',
  '_ybp._qzf': 'Оплатить',
  '_ybp._bqfyts': 'После оплаты лицензионных сборов ваши доходы и права будут защищены в первую очередь',
  '_ybp._syjl': 'История доходов',
  '_ybp._ckgd': 'Показать больше',
  '_ybp._ssdt': 'Живые обновления',
  '_ybp._bzzx': 'Центр помощи',
  '_ybp._lxkf': 'Связаться с поддержкой',
  '_ybp._zrxz': 'Доход за вчера',
  '_ybp._zdsy': 'Общий доход',
  '_ybp._qygy': 'Прошлый месяц',
  '_ybp._jsjl': 'История расчётов',
  '_ybp._hzjl': 'История переводов',
  '_ybp._jfzq': 'минут назад',
  '_ybp._fzq': 'часов назад',
  '_ybp._djs_mt': 'Сумма расчёта завтра',
  '_yj._rule': 'Правила платформы',

  '_bq._jjks': 'Начать сейчас',
  '_bq._jxz': 'В процессе',
  '_bq._jks': 'До начала',
  '_bq._jjs': 'До окончания',
  '_bq._t': 'д',
  '_bq._h': 'ч',
  '_bq._m': 'мин',
  '_bq._s': 'сек',
  '_bq._kssj': 'Время начала',
  '_bq._jssj': 'Время окончания',
  '_bqq._tzdj': 'Цена за единицу',
  '_bqq._hdts': 'Длительность акции',
  '_bqq._vip': 'VIP-уровень',
  '_bqq._rjcy': 'Среднее участие',
  '_bqq._cs': 'раз(а)',
  '_bqq._ysjd': 'Продано',
  '_bqq._ljqg': 'Купить сейчас',
  '_bqq._zbkqg': 'Временно недоступно',
  '_bqq._jzz': 'Загрузка',
  '_bqq._jzgd': 'Загрузить ещё',
  '_bqq._wz': 'Больше нет',

  '_sp._gdsj': 'Всего {n} серий',
  '_sy._jl': 'Запись ожидающих расчётов',
  '_ybp._zsy': 'Общий доход',
  '_ybp._djsjl': 'Запись ожидающих расчётов',
  '_ybp._bqbm': 'Код',
  '_ybp._je': 'Сумма',
  '_ybp._sj': 'Время',
  '_sy._djs': 'В ожидании',
  '_sy._yjs': 'Завершён',
  '_sy._gdstjl': 'Всего {n} записей',
  '_sy._gjd': 'Всего {n}',

  '_sp.tgdy':'Сумма не может быть меньше {a}',
  '_sp.tggy':'Сумма не может быть больше {a}',

  '_tg._zdyje': 'Индивидуальная сумма'
}
